import type { ISubMenu } from '../types/commonTypes';

export const FilterTypeEnum: Record<string, number> = {
  All: 1,
  ActiveOnly: 2,
  InActiveOnly: 3,
};

export const ModuleEnum: Record<string, string> = {
  Home: 'Home',
  Administration: 'Administration',
  Members: 'Members',
  Accounts: 'Accounts',
  Tickets: 'Tickets',
  VendorManagement: 'Vendor Management',
  Settings: 'Settings',
  ClientServices: 'Client Services',
};

export const ModuleNameMappingEnum: { [key: string]: string } = {
  VendorManagement: 'Vendor Management',
  Settings: 'Settings',
  Members: 'Member InSites',
  'Drug Lookup': 'Lookup',
  Testing: 'Testing',
};

export const ModuleSequence: { [key: string]: number } = {
  Home: 1,
  Accounts: 2,
  Tickets: 3,
  Clinical: 4,
  Members: 5,
  Lookup: 6,
  Testing: 7,
  'Pharmacy Network': 8,
  VendorManagement: 9,
  'Client Services': 10,

  // // Not included in side-menu
  // Administration: 21,
  // UserManagement: 22,
};

export const ModuleIconMappingEnum: { [key: string]: string } = {
  Home: 'ss-icon-home',
  Administration: 'ss-icon-admin',
  Members: ' ss-icon-memberresearch',
  Accounts: 'ss-icon-accounts',
  Tickets: 'ss-icon-support',
  Clinical: 'ss-icon-medispan',
  'Pharmacy Network': 'ss-icon-network',
  Lookup: 'ss-icon-search',
  'Drug Lookup': 'ss-icon-search',
  Testing: 'ss-icon-testing',
  'Vendor Management': 'ss-icon-carriermanagement',
  'Client Services': 'ss-icon-clientportal-gauge',
  UserManagement: 'ss-icon-settings',
};
export const ModuleLinkMappingEnum: { [key: string]: string } = {
  Home: '/home',
  Administration: '/administration',
  Members: '/member-search',
  Accounts: '/accounts',
  Tickets: '/tickets',
  Clinical: '/clinical',
  'Pharmacy Network': '/pharmacy-network',
  Lookup: '/lookup',
  Testing: '/testing',
  'Vendor Management': '/VendorManagement',
  'Client Services': '/client-services',
  UserManagement: '/administration/users',
};

export const SubModuleEnum = {
  GeneralMemberInformation: 'GeneralMemberInformation',
  AppKeys: 'AppKeys',
  RBAC: 'RBAC',
  Claims: 'Claims',
  Ticketing: 'Ticketing',
  MemberDetails: 'MemberDetails',
  Consent: 'Consent',
  Faxes: 'Faxes',
  AppPortal: 'AppPortal',

  DrugLookup: 'DrugLookup',
  ClaimLookup: 'ClaimLookup',
  Networks: 'Networks',
  Pharmacies: 'Pharmacies',
  DrugPricingManagement: 'DrugPricingManagement',
  FeeSchedules: 'FeeSchedules',
  TaxRates: 'TaxRates',
  Vendors: 'Vendors',
  PaymentCenters: 'PaymentCenters',
  RemitsCenters: 'RemitsCenters',
  OverrideAndClaimEdits: 'Override and Claim Edits',
  Lookup_ClaimReversal: 'Claim Reversal',
  Claims_ClaimReversal: 'Claim Reversal',
  FormularyTierOverrides: 'FormularyTierOverrides',
  Pharmacy_Network_ListManagement: 'Pharmacy_Network_ListManagement',
  MacLists: 'MACLists',
  MacAppeals: 'MACAppeals',

  Overrides: 'Overrides',
  EligibilityDetails: 'Eligibility Details',
  ContactDetails: 'Contact Details',
  ManualClaimManager: 'ManualClaimManager',
  DispensingFees: 'DispensingFees',
  DEDandOOP: 'DED and OOP',
  DEDandOOPManualAdjustments: 'DED and OOP Manual Adjustments',
  AccumulationRecordDownload: 'Accumulation Record Download',
  PaymentLookup: 'PaymentLookup',
  ManualClaim: 'ManualClaim',

  // VendorManagement: 'VendorManagement',
  // FileJob: 'FileJob',
  // CrosswalkConfiguration: 'CrosswalkConfiguration',
  // FileJobManager: 'FileJobManager',
  // FileJobLogs: 'FileJobLogs',
  // FileMapping: 'FileMapping',

  VendorProfile: 'VendorProfiles',
  VendorJobs: 'JobConfigurations',
  VendorSFTP: 'SFTPConfigurations',
  VendorPGP: 'PGPConfiguration',
  VendorFileMaps: 'FileMapConfigurations',
  VendorJobLogs: 'JobLogs',

  //MACListPricingLoader: 'MACListPricingLoader' // Uncomment code #27931
  Implementation: 'Implementation',
  Clinical_ListManagement: 'Clinical_ListManagement',
  AccountNotes: 'Account Notes',
  AccountAlerts: 'Account Alerts',
  MemberAlerts: 'Member Alerts',

  // CLINICAL
  ClaimEditRules: 'ClaimEditRules',
  ClaimTemplateManagement: 'ClaimTemplateManagement',
  ClinicalListManagement: 'Clinical_ListManagement',
  FormularyOverrides: 'FormularyOverrides',
  ClinicalOverrides: 'Overrides',

  // CLIENT SERVICES — must match the RBAC seed rows and the API's SubModuleEnum exactly.
  ApproveReports: 'Approve Reports',
  ClientServicesAdmin: 'Client Services Admin',
  ConsentNotes: 'Consent Notes',
};

export const AccessEnum: { [key: string]: string } = {
  FullControl: 'FullControl',
  Read: 'Read',
  Create: 'Create',
  Update: 'Update',
  Delete: 'Delete',
};

export const ModuleSubMenus: { [key: string]: ISubMenu[] } = {
  'Client Services': [
    {
      icon: 'ss-icon-approved',
      name: 'Approve Reports',
      link: '/client-services/approve-reports',
      module: SubModuleEnum.ApproveReports,
    },
  ],
  Clinical: [
    {
      icon: 'ss-icon-claimedit',
      name: 'Claim Edits',
      link: '/clinical/overview',
    },
    {
      icon: 'ss-icon-templatemanagement',
      name: 'Template Management',
      link: '/clinical/template-management',
    },
    {
      icon: 'ss-icon-listmanagement',
      name: 'List Management',
      link: '/clinical/list-management',
    },
    {
      icon: 'ss-icon-override',
      name: 'Formulary Overrides',
      link: '/clinical/formulary-overrides',
      module: SubModuleEnum.FormularyTierOverrides,
    },
    {
      icon: 'ss-icon-formularyoverrides',
      name: 'Overrides',
      link: '/clinical/overrides',
    },
  ],
  Lookup: [
    {
      icon: 'ss-icon-medication-1',
      name: 'Drug Lookup',
      link: '/lookup/drugs',
      module: SubModuleEnum.DrugLookup,
    },
    {
      icon: 'ss-icon-search',
      name: 'Claim Lookup',
      link: '/lookup/claims',
      module: SubModuleEnum.ClaimLookup,
    },
  ],
  'Pharmacy Network': [
    {
      icon: 'ss-icon-network',
      name: 'Networks',
      link: '/pharmacy-network/network',
      module: SubModuleEnum.Networks,
    },
    {
      icon: 'ss-icon-pharmacies',
      name: 'Pharmacies',
      link: '/pharmacy-network/pharmacies',
      module: SubModuleEnum.Pharmacies,
    },
    {
      icon: 'ss-icon-discount-1',
      name: 'Drug Pricing Management',
      link: '/pharmacy-network/discounts',
      module: SubModuleEnum.DrugPricingManagement,
    },
    // FIXME: Hide for now
    // {
    //   icon: 'ss-icon-listmanagement',
    //   name: 'List Management',
    //   link: '/pharmacy-network/list-management',
    //   module: SubModuleEnum.Pharmacy_Network_ListManagement,
    // },
    {
      icon: 'ss-icon-fee-schedule-1',
      name: 'Fee Schedules',
      link: '/pharmacy-network/fee-schedules',
      module: SubModuleEnum.FeeSchedules,
    },
    {
      icon: 'ss-icon-tax',
      name: 'Tax Rate Configuration',
      link: '/pharmacy-network/tax-rates',
      module: SubModuleEnum.TaxRates,
    },
    // FIXME: Hide for now
    // {
    //   icon: 'ss-icon-pharmacy',
    //   name: 'Manual Claim Manager',
    //   link: '/pharmacy-network/manual-claim-manager',
    //   module: SubModuleEnum.ManualClaimManager,
    // },
    {
      icon: 'ss-icon-priceappeal',
      name: 'Custom Pricing',
      link: '/pharmacy-network/custom-pricing',
      module: SubModuleEnum.DispensingFees,
    },
    {
      icon: 'ss-icon-card',
      name: 'Vendors',
      link: '/pharmacy-network/vendors',
      module: SubModuleEnum.Vendors,
    },
    {
      icon: 'ss-icon-payments',
      name: 'Payment Centers',
      link: '/pharmacy-network/payment-centers',
      module: SubModuleEnum.PaymentCenters,
    },
    {
      icon: 'ss-icon-remits',
      name: 'Remits Centers',
      link: '/pharmacy-network/remits',
      module: SubModuleEnum.RemitsCenters,
    },
    {
      icon: 'ss-icon-search',
      name: 'Payment Lookup',
      link: '/pharmacy-network/payment-lookup',
      module: SubModuleEnum.PaymentLookup,
    },
    {
      icon: 'ss-icon-appeals',
      name: 'MAC Appeals',
      link: '/pharmacy-network/mac-appeals',
      module: SubModuleEnum.MacAppeals,
    },
    {
      icon: 'ss-icon-noun-list',
      name: 'MAC Lists',
      link: '/pharmacy-network/mac-lists',
      module: SubModuleEnum.MacLists,
    },
  ],
  Settings: [
    {
      icon: 'ss-icon-usermanagement',
      name: 'User Management',
      link: '/administration/users',
    },
    {
      icon: 'ss-icon-support',
      name: 'Ticket Management',
      link: '/administration/ticket-management',
    },
  ],
  Testing: [
    // {
    //   icon: 'ss-icon-memberresearch',
    //   name: 'Test Member Creation',
    //   link: '/testing',
    //   module: 'Member Creation',
    // },
    // {
    //   icon: 'ss-icon-claimedit',
    //   name: 'Test Builder',
    //   link: '/testing/test-builder',
    //   module: 'Test Builder',
    // },
    // {
    //   icon: 'ss-icon-noun-list',
    //   name: 'Test Queue',
    //   link: '/testing/test-queue',
    //   module: 'Queue',
    // },
  ],
};

export const Pagination: Record<string, number> = {
  PageSize: 10,
};
// export const apiUrl = appConfig.apiUrl;

export const AccountStatusEnum = {
  Active: 1,
  Implementation: 2,
  Termed: 3,
  Evaluation: 4,
  Pending: 5,
  Lost: 6,
};

export const PlanDesignStatusEnum = {
  All: 0,
  Active: 1,
  Terminated: 2,
};

export const DRUGLIST_BUILDER_ALLOWED_OPERATORS = {
  Equals: 'Equals',
  StartsWith: 'Starts With',
};
export const DRUGLIST_BUILDER_IDENTIFIERS = {
  NDC: 'NDC',
  GPI: 'GPI',
  ALL_DRUGS: 'All Drugs',
};
export const DRUGLIST_BUILDER_VALID_VALUESLEN = {
  NDC: 11,
  GPI: 14,
};
export const CommonMessages = {
  optionalEndDate: 'Optional - Leave blank to keep active',
  endDateValidationError: "The end date can't be set prior to the start date",
  maxEndDate: '2199-12-31T00:00:00',
  notDefined: 'Not Defined',
};

export const sendCardsDefaultDays = 14;
export const allowedProfileLogoUploadExtensions = /(\.png|\.svg)$/i;
export const allowedIdCardFileUploadExtensions = /(\.png|\.svg|\.pdf)$/i;
export const MaxACAAgeLimit = 255;
export const maxEndDate = '2199-12-31T00:00:00';
export const DEFAULT_OVERRIDE_LIST_NAME = 'Override List';
export const MAXNUMBER = 100000;

export const ImportAccumulationTypeEnum = {
  Medical: 1,
  Combined: 2,
};

export const AccountContractType = {
  PBMSA: 1,
  PPSAA: 2,
};

export const FeeType = {
  AverageClaims: 1,
  HighestAdminFee: 2,
  Last3AdminFee: 3,
  PEPM: 4,
};

export const CustomCopaySourceTypeId = 4;

export const CopayProductTypeTier90 = 'Tier 90';
